import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const customerStatus = async () => axios.get(Routes.CUSTOMER_STATUS);

export const useCustomerStatus = () =>
  useQuery({
    queryKey: [Keys.CUSTOMERS_STATUS_QRY],
    queryFn: customerStatus,
  });
